import $ from 'jquery';

class CheckoutHandler{

    constructor() {
        if (document.getElementById("checkout-page")) {
            this.bindEvents();
        }
    }

    // ------------------- INIT -------------------
    bindEvents() {
        // checkout page
        $('.js-btn-next').on('click', (e) => this.validateContactLeaderFormForNext(e));
        $('.order-item .remove').on('click', (e) => this.removeSessionCart(e));
        $('.btn-place-booking button').on('click', (e) => this.placeBooking(e));
        $('.order-item .toggle-content').on('click', (e) => this.toggleContentSummary(e));
        $('.js-btn-prev').on('click', (e) => this.handlePrevClick(e));
        $("#read-cancel-policy").on("click", (e) => this.toggleCanclePolicyContent(e));
        $("#coupon-code").on("click", (e) => this.applyCouponCode(e));
    }

    async applyCouponCode(e){
        e.preventDefault();
        let couponCode = $("input[name='coupon-code']").val().trim();
        if(couponCode === "") return;
        let bodyData = {
            cartId: $("input[name='cart-id']").val(),
            couponCode: couponCode,
        }
        $('.fullscreen-spinner').removeClass('d-none');
        try {
            const response = await fetch(`${sgttData.root_url}/wp-json/sgtt/v1/cart/apply-coupon`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "X-WP-Nonce": sgttData.nonce 
                },
                body: JSON.stringify(bodyData)
            });
            const data = await response.json();
            if (response.status !== 200) {
                alert(data.message);
            }else {
                this.displayDiscountSection(data);
            }
        } catch (error) {
            // show error message
            alert(error.message);
        } finally {
            $('.fullscreen-spinner').addClass('d-none'); // hide loader afterwards
            $("input[name='coupon-code']").val(''); // clear input
        }
    }

    displayDiscountSection(cartData){
        $('.discount-lines').empty();
        cartData.discounts.forEach(discount => {
            $(".discount-lines").append(`
                <div class="d-flex justify-content-between discount-line">
                    <span>${discount.code} (${discount.text})</span>
                    <span>- <span class="discount_price">${discount.formatted_value}</span>
                    </span>
                </div>    
            `);
        });
        // total price
        $("#total_prices").text(cartData.formattedTotalPrice);
    }

    toggleCanclePolicyContent(e){
        e.preventDefault();
        if($(".cancel-policy-content").hasClass("reading")){
            $(".cancel-policy-content").fadeOut(1000).removeClass("reading");
        } else {
            $(".cancel-policy-content").fadeIn(1000).removeClass("d-none").addClass("reading");
            var targetElement = document.getElementById("cancel-policy-content");
            targetElement.scrollIntoView();
        }
    }
    handlePrevClick(e){
        $('#step-cd').addClass('js-active');
        $('#step-review').removeClass('js-active');
        $('.checkout-contact-details').removeClass('d-none');
        $('.checkout-review').addClass('d-none');
        $('#paypal-button-container').addClass('d-none');
        $('.payment-msg').addClass('d-none');
        $('.tour-cancel-policy').addClass('d-none');
        $('.btn-place-booking').addClass('d-none');
        $('.payment-type').addClass('d-none');
    }
    toggleContentSummary(e){
        let $content = $(e.target).prev('div');
        $content.toggleClass('d-none');
        $(e.target).text($content.hasClass('d-none') ? 'Show Detail' : 'Show Less');
    }

    placeBooking(e){
        e.preventDefault();
        console.log("Submitting request");
        if($(this).hasClass("disabled")){
            $('.payment-msg').removeClass('d-none');
            $('#alerts').append(" Have you agreed with the cancellation policy?");
            return false;
        } else {
            $('.payment-msg').addClass('d-none');
        }

        $.ajax({
            type: 'POST',
            url: booking_order_ajax_object.ajax_url,
            data: {
                action: "checkout_order",
                nonce: booking_order_ajax_object.nonce,
                cartId: $("input[name='cart-id']").val()
            },
            beforeSend: function () {
                $('.fullscreen-spinner').removeClass('d-none');
            },
            success: function (res) {
                // Xử lý kết quả trả về từ server
                $('.fullscreen-spinner').addClass('d-none');
                if (res.success) {
                    let checkout_url = sgttData.root_url + '/thanks?orderid=' + res.data.postID;
                    window.location.href = checkout_url;
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $('.fullscreen-spinner').addClass('d-none');
                console.log('The following error occured: ' + textStatus, errorThrown);
            }
        });
    }

    removeSessionCart(e){
        const id = $("input[name='cart-id']").val();
        $.ajax({
            url: booking_order_ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'remove_booking_order',
                cartId: id,
                nonce: booking_order_ajax_object.nonce,
            },
            success: function (response) {
                if (response.success) {
                    $('[data-id="' + id + '"]').closest('.order-item').remove();
                    location.reload();
                } else {
                    console.log(response.data.message);
                }
            }
        });
    }
    
    // ------------------- MAIN CONTACT LEADER VALIDATE FORM -------------------
    validateContactLeaderFormForNext() {
        let allValid = true; // Renamed from allFilled to allValid for clarity
        let $checkoutDetails = $('.checkout-contact-details');

        // Loop through each required input/select
        $checkoutDetails.find('input[required], select[required]').each(function () {
            $(this).closest('.form-control').removeClass('was-validated');

            // Check if the field is filled and valid
            if (!this.value || this.checkValidity() === false) {
                $(this).closest('.form-control').addClass('was-validated');
                allValid = false; // Update allValid to false if any field is invalid
            }
        });
        if (allValid) {
            let paymentValue = parseInt($('#payment').val());
            if(paymentValue > 1 && paymentValue <= 100){
                // paypal pay
                $('#paypal-button-container').removeClass('d-none');
                $('.btn-place-booking').addClass('d-none');
            } else {
                $('#paypal-button-container').addClass('d-none');
                $('.btn-place-booking').removeClass('d-none');
            }
            $checkoutDetails.addClass('d-none');
            if(paymentValue < 2 || paymentValue > 100){
                $('.payment-msg').addClass('d-none');
            }
            $('.checkout-review').removeClass('d-none');
            $('.tour-cancel-policy').removeClass('d-none');
            $('.payment-type').removeClass('d-none');
            $('#step-cd').removeClass('js-active');
            $('#step-review').addClass('js-active');

            // call to update cart
            this.updateCartInfo();
            
        } else {
            // If not all fields are valid, do not proceed and ensure the form is marked as validated
            $checkoutDetails.addClass('was-validated');
        }

    }
    
    async updateCartInfo() {
        let bodyData = {
            cartId: $("input[name='cart-id']").val(),
            contactDetails: this.getContactDetail(),
            extraFees: this.getExtraFees()
        }
        $('.fullscreen-spinner').removeClass('d-none');
        try {
            const response = await fetch(`${sgttData.root_url}/wp-json/sgtt/v1/cart/update/contact-fee`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "X-WP-Nonce": sgttData.nonce 
                },
                body: JSON.stringify(bodyData)
            });
            const data = await response.json();
            console.log("Cart Updated:", data);
            if (response.status !== 200) {
                alert(data.message);
            } else {
                this.displayReviewCheckout(data);
            }
        } catch (error) {
            alert(error.message);
        } finally {
            $('.fullscreen-spinner').addClass('d-none'); // hide loader afterwards
        }
    }

    displayReviewCheckout(cartData){
        // total price
        $("#total_prices").text(cartData.formattedTotalPrice);
        $(".payment-type").removeClass("d-none");
        $('#choosen_payment_option').text(cartData.payment.option);
        $('#need_pay_first').text(cartData.payment.formattedPayPrice);

        // contact leader info
        $("#choosen_name").text(cartData.contact_details.title + " " + cartData.contact_details.full_name);
        $("#choosen_email").text(cartData.contact_details.email);
        $("#choosen_phone").text(cartData.contact_details.phone);
        $("#choosen_nationlity").text(cartData.contact_details.nationality);
        $("#choosen_note").text(cartData.contact_details.note);
        
        const cartType = $('input[name="cart-type"]').val();
        if(cartType !== 'SERVICE'){
            // show extra fees
            $('.extra-fee-lines').empty();
            cartData.extra_fees.forEach(fee => {
                $(".extra-fee-lines").append(`
                    <div class="d-flex justify-content-between extra-fee">
                        <span>${fee.name}</span>
                        <span>${fee.formattedCost}</span>                                                        
                    </div>    
                `);
            });
            $("#choosen_dob").text(cartData.contact_details.day_of_birth);
            $("#choosen_hotel").text(cartData.contact_details.hotel_address);
        }
    }

    getContactDetail(){
        const isQuotation = $('input[name="isQuotation"]').val();
        const cartType    = $('input[name="cart-type"]').val();
        let result = {
            'full_name': $('#full_name').val().trim(),
            'email': $('#email').val().trim(),
            'phone': $('#phone').val().trim(),
            'payment': $('#payment').val().trim(),
            'nationality': $('#nationality').val().trim(),
            'note': $('#note').val().trim() + (isQuotation ? " - NEED QUOTATION" : "")
        }
        if(cartType !== 'SERVICE'){
            result.title = $('#title').val()?.trim() ?? '';
            result.day_of_birth = $('#dob').val()?.trim() ?? '';
            result.hotel_address = $('#address').val()?.trim() ?? '';
            result.pick_up = $('#pick-up').val()?.trim() ?? '';
        }
        return result;
    }

    getExtraFees() {
        return $("input[name='extra_fees']:checked")
            .map(function() {
                const [name, cost] = $(this).val().split('__');
                return {
                    name,
                    cost: parseFloat(cost) || 0
                };
            })
            .get(); // convert jQuery object to plain array
    }

    


}

export default CheckoutHandler;